import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from "react";
import { Globe } from "lucide-react";
import { Layout } from "@/components/layout/Layout";
import { DomainProtection as DomainProtectionComponent } from "@/components/security/domain/DomainProtection";

export default function DomainProtection() {
  useLanguage();
  return (
    <Layout fixedSidebar={true}>
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 pb-4 md:pt-6 md:pb-8">
          <div className="flex items-center gap-2.5 mb-4 md:mb-6">
            <Globe className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />
            <h1 className="text-[20px] md:text-[22px] font-semibold text-[#1E2330] tracking-tight leading-[1.2]">
              {translateInterfaceText("Proteção por Domínio")}</h1>
          </div>
          <DomainProtectionComponent />
        </div>
      </div>
    </Layout>
  );
}
